<template>
  <div class="template-detail main-container">
    <div class="top-info" v-if="templateDetail.id">
      <div class="left-box">
        <div class="name-box">
          <span class="name">{{ templateDetail.name }}</span>
          <span class="num">{{ templateDetail.id }}</span>
          <span class="icon icon-edit" @click="editTemplate"></span>
        </div>
        <div class="name-box">
          <span class="label">所属机构：</span>
          <span class="text">{{ templateDetail.orgName }}</span>
          <span class="label">模板类型：</span>
          <span class="text" v-if="templateDetail.type == 0">平台模板</span>
          <span class="text" v-if="templateDetail.type == 1">机构模板</span>
          <span class="text" v-if="templateDetail.type == 2">团队模板</span>
          <span class="label" v-if="templateDetail.type == 1">应用机构：</span>
          <span class="label" v-if="templateDetail.type == 2">应用团队：</span>
          <span class="text application-num" @click="openTemplateUserDetail">{{ templateDetail.applyNum }}</span>
        </div>
      </div>

      <div class="right-action">
        <span class="label">新产品自动加入模板</span>
        <Tooltip content="无权操作，请联系您的上级" v-if="!$units.pointAction('commission_20_1')" :transfer="true" :max-width="250">
          <i-Switch :disabled="true" :value="templateDetail.isExtends" true-value="1" false-value="0" />
        </Tooltip>
        <i-Switch v-else v-model="templateDetail.isExtends" true-value="1" false-value="0" @on-change="changeisExtends" />
      </div>

      <div class="right-box">
        <Button type="primary" @click="backPage">返回</Button>
        <span class="btn" @click="openBatchSetting(true)">新产品预设服务费修改 ></span>
      </div>
    </div>
    <div class="main-panel">
      <div class="search-box">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="search.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品编码</span>
          <Input v-model="search.productCode" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="search.companyCode" clearable filterable>
            <Option v-for="(item, index) in companyList" :value="item.companyCode" :key="index">{{ item.companyName }} </Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">长短险标识</span>
          <RadioGroup v-model="search.productType">
            <Radio label="">全部</Radio>
            <Radio label="1">长险</Radio>
            <Radio label="2">短险</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">险种分类</span>
          <Select v-model="search.themeId" clearable>
            <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">上架状态</span>
          <RadioGroup v-model="search.publishStatus" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="2">已上架</Radio>
            <Radio label="1">已下架</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否可售产品</span>
          <RadioGroup v-model="search.salesStatus" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="2">是</Radio>
            <Radio label="1">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="$units.showSupplier() && $units.pointAction('commission_20_5')">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="search.supplierType" @on-change="changeOriginSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div v-if="search.supplierType && $units.showSupplier() && $units.pointAction('commission_20_5')" class="input-item">
          <span class="label">供应商</span>
          <Select v-model="search.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <RadioGroup v-model="search.sellType" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">网销</Radio>
            <Radio label="3">经代</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否有费率</span>
          <RadioGroup v-model="search.isThereRate" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax">查询</Button>
          <Button v-if="$units.superviseShowVal()" type="primary" ghost @click="daochu">导出</Button>
        </div>
      </div>
      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部产品</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >项,共<span>{{ total }}</span
            >款产品</span
          >
          <Button type="primary" @click="delSelect" ghost>批量删除</Button>
          <Button type="primary" ghost @click="openBatchSetting(false)">批量配费</Button>
          <Button type="warning" @click="openAddProductModal">新增产品</Button>
          <Button v-if="$units.superviseShowVal()" type="primary" @click="importProductFee()">导入费率</Button>
        </div>
      </div>
      <div class="tableBox">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange" ref="table">
          <template slot-scope="{ row }" slot="productName">
            <div class="text-left">
              {{ row.productName }}
              <span class="tag gray" v-if="row.publishStatus == 1">已下架</span>
              <span class="tag gray" v-if="row.salesStatus == 1">停售</span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="insureCost">
            <div>{{ row.insureCost }}元起</div>
          </template>
          <template slot-scope="{ row }" slot="fee">
            <div :class="{ 'red-text': row.isTemplate == 0 }" style="margin-right: 0">
              <template v-if="row.min != row.max">
                <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
              </template>
              <span v-else>{{ row.min }}%</span>
            </div>
            <div class="huo" v-if="row.activityInfoVO && templateDetail.type == 3"><i>活</i>最高达{{ row.activityInfoVO.commission }}%</div>
          </template>
          <template slot-scope="{ row }" slot="salesAuth">
            <span v-if="row.salesAuth == 1">是</span>
            <span v-else-if="row.salesAuth == 0" style="color: #ed4014">否</span>
            <span v-else>-</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="seeRate(row)">查看费率</span>
            <span class="table-btn red" @click="delProduct(row)">删除</span>
          </template>
        </Table>
        <Page
          :total="total"
          :current.sync="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="getList"
          show-sizer
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="
            pageSize = $event;
            getList();
          "
          style="text-align: center; margin-top: 20px"
        />
      </div>
    </div>

    <!-- 模板新增、编辑 -->
    <editTemplate
      ref="editTemplate"
      @success="
        templateDetail.name = $event.name;
        getTemplateDetail();
      "
    ></editTemplate>
    <!-- 新增产品 -->
    <addProduct ref="addProduct" @success="searchAjax" :showSupplier="$units.pointAction('commission_20_5')"></addProduct>
    <!-- 批量配置 -->
    <batchSetting ref="batchSetting" @success="successBatchSetting"></batchSetting>
    <!-- 模板使用详情 -->
    <templateUserDetail ref="templateUserDetail" @success="getTemplateDetail"></templateUserDetail>
    <!-- 导入费率 -->
    <import-Product-fee ref="importProductFee" pageType="template" @success="searchAjax"></import-Product-fee>
  </div>
</template>

<script>
import templateUserDetail from '@/components/commons/feeTemplate/templateUserDetail';
import batchSetting from '@/components/commons/feeTemplate/batchSetting';
import addProduct from '@/components/commons/feeTemplate/addProduct';
import rateTable from '@/components/commons/feeTemplate/rateTable';
import editTemplate from '@/components/commons/feeTemplate/editTemplate';
import importProductFee from '@/components/commons/importProductFee/index';
import { mapState } from 'vuex';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: { addProduct, batchSetting, rateTable, editTemplate, templateUserDetail, importProductFee },
  props: {},
  data() {
    return {
      id: '', //模板id
      templateDetail: {}, //模板详情数据
      detail: {}, //模板详情数据
      search: {
        salesAuth: ''
      }, //查询数据
      isAll: false,
      selectArr: [], //选中的产品code
      isLongOrShort: [true, true], //选中的产品是否有长短险
      tableLoading: false, //表格loading
      columns: [],
      supplierList: [],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1, //当前页
      form: {}, //表单数据
      formVisible: false //表单弹窗
    };
  },
  computed: {
    ...mapState({
      companyList: 'companyList', //保险公司
      themeList: 'themeList' //产品分类
    })
  },
  created() {
    let columns = [
      //表格字段
      {
        type: 'selection',
        width: 60,
        align: 'center'
      },
      {
        title: '产品名称',
        slot: 'productName',
        align: 'center',
        minWidth: 140
      },
      {
        title: '产品编码',
        key: 'productCode',
        align: 'center',
        minWidth: 100
      }
    ];
    if (this.$units.pointAction('commission_20_5')) {
      columns.push({
        title: '供应商',
        key: 'supplierName',
        align: 'center',
        minWidth: 100
      });
    }
    columns.push(
      {
        title: '保险公司',
        key: 'companyName',
        align: 'center',
        minWidth: 100
      },
      {
        title: '服务费率',
        slot: 'fee',
        align: 'center',
        minWidth: 140
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 150
      }
    );
    this.columns = columns;
  },
  activated() {
    this.id = this.$route.query.id;
    this.templateDetail = {
      type: this.$route.query.type,
      orgId: this.$route.query.orgId
    };
    this.searchAjax();
    this.getTemplateDetail();
    this.getImportFeeProgress();
  },
  methods: {
    changeOriginSupplierType(value) {
      this.search.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },
    // 导入费率
    importProductFee() {
      if (!this.$units.pointAction('commission_20_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let uploadUrl = '/buz/commission/config/importCommissionByTemOrgId?temId=';
      if (this.$route.query.type == 2) {
        uploadUrl = '/buz/commission/config/importCommissionByTemGroupId?temId=';
      }
      uploadUrl += this.id;
      const params = this.getParams();
      params.dataLock = true;
      this.$refs.importProductFee.open({
        uploadUrl,
        downloadUrl: '/buz/commission/template/export',
        nodeType: this.templateDetail.type,
        downloadParams: params
      });
    },
    // 获取导入产品费率进度
    getImportFeeProgress() {
      this.$refs.importProductFee.getProgress();
    },
    // 导出
    daochu() {
      if (!this.$units.pointAction('commission_20_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/commission/template/export', this.getParams(), 'POST');
    },
    backPage() {
      // 费用配置跳转:commissionConfig、费用模板跳转:commissionTemplate
      let pageKey = this.$route.query.redirectPagePath;
      if (pageKey == 'commissionConfig') {
        localStorage.setItem('updataOrgAndTeam', 1);
        this.back('/productResource/fee/config');
      } else if (pageKey == 'commissionTemplate') {
        this.back('/productResource/fee/templateList');
      }
      this.$destroy(); // 调用组件的销毁
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    initSelect() {
      this.$store.dispatch('getCompanyList');
      this.$store.dispatch('getThemeList');
    },
    // 新产品自动加入模板
    changeisExtends(val) {
      this.$http({
        url: '/buz/template/edit',
        type: 'POST',
        data: {
          ...this.templateDetail,
          isExtends: val
        }
      }).then(res => {
        this.searchAjax();
        this.getTemplateDetail();
      });
    },
    // 编辑模板弹窗
    editTemplate() {
      if (!this.$units.pointAction('commission_20_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.editTemplate.open(Object.assign({}, this.templateDetail));
    },
    // 查看费率
    seeRate(row) {
      this.openPageTabTags('/productResource/fee/templateRateDetail', {
        productName: row.productName,
        templateName: this.templateDetail.name,
        templateId: this.templateDetail.id,
        companyName: row.companyName,
        productCode: row.productCode,
        nodeType: this.templateDetail.type,
        orgId: this.templateDetail.orgId
      });
    },
    // 删除模板的单个产品
    delProduct(data) {
      if (!this.$units.pointAction('commission_20_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('确定删除产品？').then(() => {
        this.delAjax([data.productCode]);
      });
    },
    // 批量删除
    delSelect() {
      if (!this.$units.pointAction('commission_20_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (this.selectArr.length == 0 && !this.isAll) {
        this.$notice.msg('请至少选择一个产品');
        return;
      }
      this.$notice.inquiry('确定删除产品？').then(() => {
        this.delAjax(this.selectArr);
      });
    },
    // 删除产品请求
    delAjax(productCodes) {
      if (this.tableLoading) {
        return;
      }
      this.tableLoading = true;
      this.$http({
        url: '/buz/templateProduct/delTemplateProduct',
        type: 'post',
        data: {
          templateId: this.id,
          nodeType: this.templateDetail.type,
          productCodes: productCodes,
          isAll: productCodes.length ? false : this.isAll,
          ...this.search
        }
      })
        .then(res => {
          this.isAll = false;
          this.$notice.success('删除模板产品成功');
          this.searchAjax();
        })
        .finally(e => {
          this.tableLoading = false;
        });
    },
    // 获取模板详情数据
    getTemplateDetail() {
      this.$http({
        url: '/buz/template/read/detail',
        type: 'get',
        data: {
          id: this.id
        }
      }).then(res => {
        this.templateDetail = res.data;
      });
    },
    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      params.templateId = this.id;
      if (params.productCode) {
        params.productCodeList = [params.productCode];
      }
      delete params.productCode;
      return params;
    },
    searchAjax() {
      this.isAll = false; //全选
      this.selectArr = [];
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      params.nodeType = this.templateDetail.type;
      this.tableLoading = true;
      this.$http({
        url: '/buz/templateProduct/queryTemplateProduct',
        type: 'post',
        data: params
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.productCode == item2) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.initSelect();
          this.tableData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    // 批量配费成功
    successBatchSetting() {
      this.isAll = false;
      this.selectArr = [];
      this.searchAjax();
    },
    // 新增产品弹窗
    openAddProductModal() {
      if (!this.$units.pointAction('commission_20_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.addProduct.open({
        template: {
          id: this.id,
          type: this.templateDetail.type
        },
        isNewTemplate: false,
        id: this.templateDetail.orgId,
        handleSource: 1
      });
    },
    // 打开批量配置
    openBatchSetting(isCommon) {
      if (!this.$units.pointAction('commission_20_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (!isCommon && this.selectArr.length == 0 && !this.isAll) {
        this.$notice.msg('请至少选择一个产品');
        return;
      }
      const params = {
        isCommon: !isCommon,
        template: {
          id: this.id,
          type: this.templateDetail.type
        },
        templateId: this.id,
        isAll: this.isAll,
        orgId: this.templateDetail.orgId,
        productCodes: this.isAll ? [] : this.selectArr,
        type: this.templateDetail.type,
        search: this.search
      };
      this.$refs.batchSetting.open(params);
    },
    // 应用团队/机构
    openTemplateUserDetail() {
      this.$refs.templateUserDetail.open(this.templateDetail);
    },
    openForm(item) {
      this.form = item;
      this.formVisible = true;
    },

    onSelectChange(curSelectArr) {
      const codes = curSelectArr.map(item => item.productCode); //当前页勾选的
      const selectCodes = this.selectArr.map(item => item); //已经添加的数据
      this.tableData.forEach(item => {
        if (codes.includes(item.productCode) && !selectCodes.includes(item.productCode)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item.productCode);
          selectCodes.push(item.productCode);
        } else if (!codes.includes(item.productCode) && selectCodes.includes(item.productCode)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectCodes.indexOf(item.productCode), 1);
          selectCodes.splice(selectCodes.indexOf(item.productCode), 1);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './templateDetail.scss';
</style>